import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import HeroCarousel from "./components/HeroCarousel";
import StatsStrip from "./components/StatsStrip";
import FeaturedFilms from "./components/FeaturedFilms";
import NewsHighlights from "./components/NewsHighlights";
import ServicesSection from "./components/ServicesSection";

export default function Home() {
  useSEO({
    title: "星光传媒｜专业影视制作与传媒服务平台",
    description:
      "星光传媒专注于影视内容的制作与传播，涵盖电影、电视剧、综艺等多种类型，致力于为用户提供最新最全面的影视资讯与传媒服务体验。",
    keywords: "星光传媒,影视制作,影视资讯,电影制作,电视剧内容,传媒服务,影视平台",
  });

  return (
    <>
      <HeroCarousel />
      <StatsStrip />
      <FeaturedFilms />
      <NewsHighlights />
      <ServicesSection />

      {/* CTA band */}
      <section className="bg-primary-900">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-6 px-4 py-12 text-center md:px-6 md:py-16">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-200">
            <i className="ri-film-line" />
            让每一个好故事都被看见
          </span>
          <h2 className="max-w-2xl font-heading text-2xl font-bold text-background-50 md:text-3xl">
            有影视项目或品牌传播需求？和星光传媒聊聊
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-background-300">
            无论是内容制作、宣传发行还是品牌影像，我们都可以提供从创意到落地的全链路支持。
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              合作咨询
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              了解星光传媒
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}